








































































































import { Component, Mixins } from 'vue-property-decorator';
import { appName, appEnv, gitCommitShortSHA, versionTag } from '@/env';
import { readUserProfile } from '@/store/main/getters';
import { dispatchUserLogOut } from '@/store/main/actions';
import NavBarMixin from '../mixins/NavBarMixin';
import { api } from '@/api';

@Component
export default class NavBar extends Mixins(NavBarMixin) {
  public appName = appName;
  public appEnv = appEnv;
  public toggle = false;
  public gitCommitShortSHA = gitCommitShortSHA;
  public versionTag = versionTag;

  public toggleMenu() {
    this.toggle = !this.toggle;
  }
  public goToHome() {
    const route = { name: 'home' };
    this.$router.push(route);
  }

  public get appTitle() {
    if (appEnv === 'staging') {
      return 'BMI - STAGING';
    } else {
      return appName;
    }
  }

  public get userDisplayName() {
    const profile = readUserProfile(this.$store);
    return profile ? profile.display_name : '';
  }

  public async logout() {
    await dispatchUserLogOut(this.$store);
  }

  public async downloadManual() {
    const response = await api.getChoices(
      undefined,
      '/sitereportlayouts/choice/',
      {
        report_layout_type: 3
      }
    );
    if (response) {
      for (const doc of response.data.records) {
        if (doc.text === 'Handleiding') {
          api.downloadFile(
            this.$store,
            '/sitereportlayouts/' + doc.value + '/file/url'
          );
        }
      }
    }
  }
}
